import React from "react";
import PropTypes from "prop-types";
import SectionItem from "./SectionItem.jsx";

const storageDays = {
  30: "1 month",
  60: "2 months",
  90: "3 months",
  120: "4 months",
  150: "5 months",
  180: "6 months",
  210: "7 months",
  240: "8 months",
  270: "9 months",
  300: "10 months",
  330: "11 months",
  365: "1 year",
  730: "2 years",
  1095: "3 years",
  1460: "4 years",
  1825: "5 years",
  2190: "6 years",
  2555: "7 years",
};

export const OnlinePlayback = (props) =>
  (props.enabled && (
    <span>
      <SectionItem itemKey={"Online Playback"}>Enabled</SectionItem>
      {props.enabled && props.storageDays && (
        <SectionItem itemKey={"Delete After"}>
          {storageDays[props.storageDays]}
        </SectionItem>
      )}
    </span>
  )) ||
  null;

export default OnlinePlayback;

OnlinePlayback.propTypes = {
  enabled: PropTypes.bool,
  storageDays: PropTypes.number,
};
